// extracted by mini-css-extract-plugin
export default {"fullPageContainer":"ErrorBoundary__fullPageContainer___1opmN","container":"ErrorBoundary__container___1yLA8","box":"ErrorBoundary__box___1823T"};